import { hideLaunchEditOnMobile } from '~commonInfra/utils/MobileHelper';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { ILaunchConnectedExperience } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ContentType,openWorkbookInDesktop } from '../actions/OpenWorkbookInDesktopAction';

export const OpenWorkbookInDesktopAction: IEntityAction<IContentInfo<ContentType.Workbook | ContentType.View>, ILaunchConnectedExperience> = {
  name: EntityActionNames.OpenWorkbookInDesktop,
  translateName: Messages.openWorkbookInDesktop,
  isVisible: (_targetItems: IContentInfo[]) => {
    return !hideLaunchEditOnMobile();
  },
  isClickable: (availableActions?: ILaunchConnectedExperience) => {
    return !!availableActions && availableActions.launchConnectedExperience;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return openWorkbookInDesktop(targetItems[0]);
  }
};
